'use client';
import { defaultLocale, domainToLocaleMapping } from '@/core/constants';
import { useEffect, useState } from 'react';

function evaluateLocaleFromURL(href: string) {
  const matchedLocales = Object.keys(domainToLocaleMapping).filter(
    (localeIdentifier) => href.includes(localeIdentifier),
  ) as (keyof typeof domainToLocaleMapping)[];
  // In the event the array is empty, it implies there is no TLD and is therefore `localhost`
  if (!matchedLocales || !matchedLocales?.length) return defaultLocale;

  return domainToLocaleMapping[matchedLocales[0]];
}

export default function useLocale() {
  const [locale, setLocale] = useState(defaultLocale);
  const href = globalThis.location?.href;

  useEffect(() => {
    if (typeof globalThis.location === 'undefined') return;
    const newLocale = evaluateLocaleFromURL(href);
    if (locale !== newLocale) setLocale(newLocale);
  }, [href, locale]);

  return locale;
}
